import type { MeQuery } from "generated/graphql";
import type { UserRole } from "@modules/authentication/roles";
import { atom } from "jotai";

export type CurrentUserState = {
  status: "idle" | "loading" | "loaded" | "error";
  user?: MeQuery["me"] & {
    role?: UserRole;
  };
  error?: Error;
  requestId: number;
};

export const currentUserStateAtom = atom<CurrentUserState>({
  status: "idle",
  requestId: 0,
});
